(() => {
  function openLinkedDetails() {
    if (window.location.hash !== '#ContactCompanyDetails') return;
    const details = document.getElementById('ContactCompanyDetails');
    if (!details) return;
    details.open = true;
    requestAnimationFrame(() => details.scrollIntoView({block: 'start'}));
  }
  openLinkedDetails();
  window.addEventListener('hashchange', openLinkedDetails);
  document.addEventListener('shopify:section:load', openLinkedDetails);
})();
